import { Fragment } from 'react'
import ZoomAppRemovePage from '../../../../../assets/images/zoom-integration-remove-1024w.webp'
import ZoomCompanionModeOn from '../../../../../assets/images/zoom-companion-mode-on.png'
import ZoomCompanionModeOff from '../../../../../assets/images/zoom-companion-mode-off.png'
import { ScopedBlock } from '../../../../../components/ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../../../../../components/ScopedBlock/models'

export const ZoomHowItWorks: React.FC = () => {
  return (
    <Fragment>
      <div>
        <p>
          Zocks' Zoom integration allows you to have your Zocks AI Notetaker with you on your Zoom meetings so that you can focus on your client while Zocks
          captures accurate, actionable, and 100% recording-free notes, so you never miss a detail.
        </p>
        <p>
          With our native Zoom plugin you can access meeting prep materials, real-time client insights, and task management live during your meeting, without
          ever leaving Zoom.
        </p>
      </div>
      <h4 className='mt-5 mb-3'>Before you connect</h4>
      <div>
        <p>
          Zocks connects to whichever Zoom account you're currently signed into in your browser. If you have multiple Zoom accounts, you'll be asked to choose
          one when connecting.
        </p>
        <p>To connect the right account, sign out of Zoom in your browser first. Sign back in with the account you want to use, then return here to connect.</p>
      </div>
      <h4 className='mt-5 mb-3'>Wrong Zoom account connected?</h4>
      <div>
        <p>
          If you connected the wrong Zoom account, you can remove the Zocks app from Zoom's App Marketplace. Go to your installed apps, remove Zocks Meeting,
          then sign back in to Zoom with the correct account and reconnect here.
        </p>
        <p>
          Manage your installed Zoom apps at{' '}
          <a href='https://marketplace.zoom.us/user/installed' target='_blank' rel='noopener noreferrer'>
            marketplace.zoom.us/user/installed
          </a>
          .
        </p>
        <img src={ZoomAppRemovePage} alt='Zoom App Remove Page' className='mw-100' />
      </div>
      <ScopedBlock missingScopeAction={MissingScopeAction.HIDE} quota={{ quota: 'integration.zoomStrictJoinEnabled.value' }}>
        <h4 className='mt-5 mb-3'>About companion mode</h4>
        <div>
          <p>
            In companion mode, the AI Assistant joins as a named guest linked to your identity. It enters when you join and leaves when you do. Without
            companion mode, the AI Assistant joins as a separate participant when the meeting starts and stays in the meeting independently of you until the
            meeting ends.
          </p>
          <div className='row g-3 mt-2'>
            <div className='col-12 col-md-6'>
              <div className='d-flex align-items-center justify-content-center'>
                <img src={ZoomCompanionModeOn} alt='Zoom participants list in companion mode' className='mw-100' />
              </div>
              <p className='paragraph-small zocks-text-gray-600 text-center mt-2 mb-0'>In companion mode</p>
            </div>
            <div className='col-12 col-md-6'>
              <div className='d-flex align-items-center justify-content-center'>
                <img src={ZoomCompanionModeOff} alt='Zoom participants list with companion mode disabled' className='mw-100' />
              </div>
              <p className='paragraph-small zocks-text-gray-600 text-center mt-2 mb-0'>Disabled companion mode</p>
            </div>
          </div>
        </div>
      </ScopedBlock>
    </Fragment>
  )
}
